import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'

import { useAuth } from '@sputnik/auth'
import { logInfo } from '@sputnik/utils/loggerUtils'

import MobileDocumentUploadStatus from './MobileDocumentUploadStatus'
import UploadContent from './UploadContent'

const MobileDocumentUpload = () => {
  const { getCreditAppIdOnToken, isAuthExpired, isAuthenticated } = useAuth()
  const creditApplicationId = getCreditAppIdOnToken()

  useDidMount(() =>
    logInfo('scanQRCode', {
      attributes: {
        creditAppId: creditApplicationId,
        result: 'User switched to a mobile device for a document upload',
      },
      eventName: 'MobileDeviceQrDocumentUpload',
    }),
  )

  if (isAuthenticated && !isAuthExpired()) {
    return <UploadContent />
  } else {
    return <MobileDocumentUploadStatus page='invalidLink' />
  }
}

export default MobileDocumentUpload
